import {whenAppears} from "./whenAppears.js";
import {autocompleteItem} from "./autocompleteItem.js";

export const autocomplete = class {

    constructor(rest_url) {
        whenAppears('.fcwp_autocomplete', function(element) {
            new autocompleteItem(element, rest_url);
        });
    }
}